import {
  createGooglePageViewPayload,
  createGoogleTagFunction,
  createGoogleTagScriptSrc,
  normalizeAnalyticsId,
  runIsolatedAnalyticsTask,
  shouldEnableAnalytics
} from '~/utils/analyticsGate';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const measurementId = normalizeAnalyticsId(config.public.googleAnalyticsMeasurementId as string);
  const nodeEnv = process.env.NODE_ENV || '';
  let lastTrackedPath = '';

  // 仅在生产环境且配置了 ID 时加载统计代码
  if (!shouldEnableAnalytics({ id: measurementId, nodeEnv })) {
    return;
  }

  const trackPageView = (fullPath: string) => {
    if (!window.gtag) {
      return;
    }

    if (fullPath === lastTrackedPath) {
      return;
    }

    const payload = createGooglePageViewPayload({
      fullPath,
      href: window.location.href,
      title: document.title
    });

    window.gtag('event', 'page_view', payload);
    lastTrackedPath = payload.page_path;
  };

  runIsolatedAnalyticsTask(() => {
    if (!document.getElementById('google_analytics')) {
      const script = document.createElement('script');
      script.id = 'google_analytics';
      script.async = true;
      script.src = createGoogleTagScriptSrc(measurementId);
      document.head.appendChild(script);
    }

    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
      window.gtag = createGoogleTagFunction(window.dataLayer);
    }

    window.gtag('js', new Date());
    window.gtag('config', measurementId, { send_page_view: false });
    trackPageView(window.location.pathname + window.location.search);
  });

  const router = useRouter();
  router.afterEach((to) => {
    runIsolatedAnalyticsTask(() => {
      trackPageView(to.fullPath);
    });
  });
});
